import axiosTokenInstance from "../../../services/api/backoffice";

import { NIR, NIR_ERROR } from "_models/redux/types";

// Action function
export const getNir = (params) => async (dispatch) => {
    const { state_id } = params || {
        state_id: undefined,
    };

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/sepomex/states/${state_id}/nirs`
        );

        const { data } = response || {};

        dispatch({
            type: NIR,
            payload: data || {},
        });
    } catch (e) {
        dispatch({
            type: NIR_ERROR,
            payload: e || {},
        });
    }
};
